let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5gZ24")).then(() => parcelRequire('3jQNk'));